var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDesktop = function SvgIconDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 16.125a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1.25h16zM2 6v10.125a2.5 2.5 0 0 0 2.5 2.5H11V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-1.375h6.5a2.5 2.5 0 0 0 2.5-2.5V6a2.5 2.5 0 0 0-2.5-2.5h-15A2.5 2.5 0 0 0 2 6m2 0v6.875h16V6a.5.5 0 0 0-.5-.5h-15A.5.5 0 0 0 4 6",
    clipRule: "evenodd"
  })));
};
export default SvgIconDesktop;